export default {
  COLLECTION_TYPE_SEASONAL: 'seasonal',
  COLLECTION_TYPE_TIMELESS: 'timeless',
  COLLECTION_TYPE_PRODUCT_FOCUS: 'productFocuses',
};
